<script setup lang="ts">
import { URL_IMAGE } from '@/config/constants'
import { toggleShowModalBasketHappy } from '@/happyTheme/utils/modalBasket/toggleShowModalBasketHappy'
import InputQuantityBasketHappy from './inputQuantityBasketHappy.vue'
import { getPrice } from '@/utils/product/getPrice'
import { totalPrice } from '@/utils/price/totalPrice'
import { convertPriceToEuroHappy } from '@/happyTheme/utils/product/convertPriceToEuroHappy'
import { basketCart } from '@/event/basket/basketCart'
import { numberBasket } from '@/event/basketBus'
import { messageAlertElementBasketHappy } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import AlertElementBasketHappy from './alert/AlertElementBasketHappy.vue'
import { useRouter } from 'vue-router'
import { showModalBasketHappyTransition } from '@/happyTheme/event/modalBasket/showModalBasketHappy'

const router = useRouter()

function validateOrder() {
    toggleShowModalBasketHappy()
    setTimeout(() => {
        router.push('/basket/order')
    }, 350)
}
</script>

<template>
    <section class="section-modal-basket-happy">
        <section
            class="section-modal-basket-overlay-happy"
            @click="toggleShowModalBasketHappy()"
        ></section>

        <AlertElementBasketHappy
            v-if="messageAlertElementBasketHappy.message.length !== 0"
        />

        <transition
            name="basket"
            enter-active-class="transition-transform duration-300 ease-out"
            enter-from-class="-translate-y-full"
            enter-to-class="translate-y-0"
            leave-active-class="transition-transform duration-300 ease-out"
            leave-from-class="translate-y-0"
            leave-to-class="-translate-y-full"
        >
            <section
                class="section-modal-basket-content-happy"
                v-if="showModalBasketHappyTransition"
            >
                <section class="section-modal-basket-design-happy">
                    <div class="div-modal-basket-title-happy">
                        <p class="p-basket-happy">Panier</p>
                        <svg
                            @click="toggleShowModalBasketHappy()"
                            class="svg-cross-modal-basket-happy"
                            viewBox="0 0 30 30"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M23.75 6.25L6.25 23.75M6.25004 6.25L23.75 23.75"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>

                    <section v-if="basketCart.length !== 0">
                        <div class="div-modal-basket-content-happy">
                            <div
                                class="div-product-basket-happy"
                                :class="{
                                    'div-product-basket-border-happy':
                                        i !== basketCart.length - 1
                                }"
                                v-for="(p, i) in basketCart"
                                :key="i"
                            >
                                <div class="flex">
                                    <img
                                        class="img-product-basket-happy"
                                        :src="`${URL_IMAGE}${p.product_image}`"
                                        alt=""
                                    />
                                    <div class="div-content-product-basket-happy">
                                        <p class="name-product-basket-happy">
                                            {{ p.product }}
                                        </p>
                                        <div
                                            class="div-content-information-product-happy"
                                        >
                                            <InputQuantityBasketHappy :index="i" />
                                            <p class="price-basket-product-happy">
                                                {{ getPrice(p.total_price) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="div-option-basket-happy"
                                    v-if="Object.keys(p.groupedOptions).length > 0"
                                    v-for="(o, _i) in p.groupedOptions"
                                >
                                    <svg
                                        fill="none"
                                        viewBox="0 0 14 11"
                                        class="svg-option-basket-happy"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.43483 4.35783L12.2604 7.18344M12.2604 7.18344L9.43483 10.009M12.2604 7.18344H2.01761C1.43241 7.18344 0.958008 6.70906 0.958008 6.12384V1.53223"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <div class="div-content-option-basket-happy">
                                        <p
                                            class="text-wrap text-[14px] leading-[16px] font-semibold"
                                        >
                                            {{ _i + ' :' }}
                                        </p>
                                        <div v-if="o.length !== 0" v-for="(ov, iov) in o">
                                            <span
                                                class="text-[13px] leading-[15px] whitespace-nowrap flex"
                                            >
                                                {{ ov.productName }}
                                                <p v-if="iov !== o.length - 1">,</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            class="bottom-basket-modal-happy"
                            @click="validateOrder()"
                        >
                            <div class="relative flex justify-center">
                                <svg
                                    class="svg-basket-happy"
                                    viewBox="0 0 30 34"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M29.3059 32.1838L27.4064 8.67824C27.3689 8.21454 26.9817 7.85727 26.5164 7.85727H21.4172V6.7269C21.4172 3.01767 18.4393 0 14.7299 0H14.6121C10.9028 0 7.84552 3.01767 7.84552 6.7269V7.85727H2.82555C2.36031 7.85727 1.97304 8.21454 1.93554 8.67824L0.0307451 32.2501C0.0106257 32.4986 0.0953889 32.7441 0.264439 32.9273C0.43349 33.1106 0.671589 33.2148 0.92076 33.2148H28.4212C28.4219 33.2148 28.4229 33.2148 28.4236 33.2148C28.9168 33.2148 29.3165 32.8152 29.3165 32.322C29.3165 32.2749 29.3129 32.2288 29.3059 32.1838ZM9.63126 6.7269C9.63126 4.00233 11.8875 1.78574 14.6121 1.78574H14.7299C17.4545 1.78574 19.6314 4.00233 19.6314 6.7269V7.85727H9.63126V6.7269Z"
                                    />
                                </svg>
                                <p
                                    class="absolute text-[14px] font-bold text-text-dark-happy-light top-1"
                                >
                                    {{ numberBasket }}
                                </p>
                            </div>
                            <p class="font-semibold">Valider mon panier</p>
                            <p class="price-product-basket-happy">
                                {{ convertPriceToEuroHappy(totalPrice) }}
                            </p>
                        </button>
                    </section>
                    <section v-else class="h-14 flex items-center justify-center">
                        <p class="font-semibold">Le panier est vide</p>
                    </section>
                </section>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-modal-basket-happy {
    @apply w-screen h-full fixed flex flex-col items-center top-0 left-0 z-30;
}

.section-modal-basket-overlay-happy {
    @apply w-screen h-full;
}

.section-modal-basket-content-happy {
    @apply absolute top-20 z-10 p-1 w-full;
    @apply flex flex-col;
}

.section-modal-basket-design-happy {
    @apply happy-dark:bg-text-dark-happy-light rounded-md happy-light:bg-bg-happy-light;
    @apply shadow-sm happy-light:shadow-text-dark-happy-light happy-dark:shadow-bg-happy-light;
    @apply flex flex-col border-2 border-border-gray-happy-light;
}

.div-modal-basket-title-happy {
    @apply bg-border-gray-happy-light rounded-t-sm p-2 text-text-dark-happy-light font-semibold flex justify-between items-center;
}

.svg-cross-modal-basket-happy {
    @apply w-7 h-7 stroke-text-dark-happy-light;
}
.svg-cross-modal-basket-happy:active {
    @apply stroke-border-red-happy-light;
}

.div-modal-basket-content-happy {
    @apply flex flex-col max-h-[28rem] overflow-auto;
}

.div-product-basket-happy {
    @apply p-2 flex max-w-full flex-col gap-2;
}

.div-product-basket-border-happy {
    @apply border-b happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
}

.img-product-basket-happy {
    @apply max-w-14 object-contain;
}

.div-content-product-basket-happy {
    @apply px-1 min-w-0 flex-1;
}

.name-product-basket-happy {
    @apply pt-1 font-bold;
}

.div-content-information-product-happy {
    @apply flex justify-between;
}

.price-basket-product-happy {
    @apply font-semibold;
}

.div-option-basket-happy {
    @apply pl-6 flex items-start gap-1;
}

.svg-option-basket-happy {
    @apply min-w-4 max-w-4 min-h-4 max-h-4;
    @apply happy-light:stroke-text-dark-happy-light happy-dark:stroke-bg-happy-light;
}

.div-content-option-basket-happy {
    @apply flex flex-wrap items-center gap-1 transition-all duration-500 ease-out;
}

.bottom-basket-modal-happy {
    @apply bg-text-basket-option-light-happy text-bg-happy-light w-full rounded-b-[0.28rem] flex flex-row items-center border-t py-2 pl-3 pr-3  min-h-12 justify-between;
}

.bottom-basket-modal-happy:active {
    @apply bg-banner-gray-component-happy-light text-text-dark-happy-light  happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
}

.svg-basket-happy {
    @apply w-6 h-6 fill-button-yellow-happy-light;
}

.price-product-basket-happy {
    @apply font-semibold text-button-yellow-happy-light;
}

@media screen and (min-width: 376px) {
    .section-modal-basket-content-happy {
        /* @apply ; */
        /* @apply; */
    }
}

@media screen and (min-width: 400px) {
    .section-modal-basket-content-happy {
        @apply w-[24.9rem];
    }
}

@media screen and (min-width: 550px) {
    .section-modal-basket-content-happy {
        @apply right-12;
    }
}

@media screen and (min-width: 1300px) {
    .section-modal-basket-content-happy {
        @apply right-16;
    }
}

@media screen and (min-width: 1400px) {
    .section-modal-basket-content-happy {
        @apply right-28;
    }
}

@media screen and (min-width: 1500px) {
    .section-modal-basket-content-happy {
        @apply right-44;
    }
}

@media screen and (min-width: 1600px) {
    .section-modal-basket-content-happy {
        @apply right-52;
    }
}

@media screen and (min-width: 1700px) {
    .section-modal-basket-content-happy {
        @apply right-64;
    }
}

@media screen and (min-width: 1800px) {
    .section-modal-basket-content-happy {
        @apply right-80;
    }
}

@media screen and (min-width: 2000px) {
    .section-modal-basket-content-happy {
        @apply right-96;
    }
}

@media screen and (min-width: 2100px) {
    .section-modal-basket-content-happy {
        @apply right-[32rem];
    }
}
@media screen and (min-width: 2400px) {
    .section-modal-basket-content-happy {
        @apply right-[39rem];
    }
}

@media (hover: hover) {
    .svg-cross-modal-basket-happy:hover {
        @apply stroke-border-red-happy-light;
    }
    .bottom-basket-modal-happy:hover {
        @apply bg-text-dark-happy-light;
    }
}
</style>
